// mutations
const PAPELERIA_REPORTS_ALL = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_FORM = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_SHOW = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_CREATE = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
    alert(papeleriaReports.message)
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_UPDATE = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
    alert(papeleriaReports.message)
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_DELETE = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
    alert(papeleriaReports.message)
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_PERMISS_LIST = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(papeleriaReports.message)
    state.status = 'error'
  }
}

const PAPELERIA_REPORTS_REPORTS_LIST = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const PAPELERIA_REPORTS_REPORTS_RVDP = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const PAPELERIA_REPORTS_REPORTS_RM = (state, papeleriaReports) => {
  if (papeleriaReports.code === 1) {
    state.papeleriaReports = papeleriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_REPORTS_ALL,
  PAPELERIA_REPORTS_FORM,
  PAPELERIA_REPORTS_SHOW,
  PAPELERIA_REPORTS_CREATE,
  PAPELERIA_REPORTS_UPDATE,
  PAPELERIA_REPORTS_DELETE,
  PAPELERIA_REPORTS_PERMISS_LIST,
  PAPELERIA_REPORTS_REPORTS_LIST,
  PAPELERIA_REPORTS_REPORTS_RVDP,
  PAPELERIA_REPORTS_REPORTS_RM
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/reports/mutations.js